import axios from "axios";
// import { MEDIA_API_URL } from '../../env'
import { getSessionToken } from "../session";

const MEDIA_API_URL = process.env.REACT_APP_MEDIA_API_URL;

async function uploadFileRequest(filePath, file) {
  // Validate file type
  if (!file.type.startsWith("image/")) {
    throw new Error("Only image files are allowed");
  }

  const formData = new FormData();
  // Append file with explicit filename to preserve extension
  formData.append("file", file, file.name);

  const fileHeaders = {
    Authorization: `Bearer ${getSessionToken()}`,
    Accept: "application/json",
    // Remove Content-Type header to let browser set it automatically
  };

  const uploadUrl = `${MEDIA_API_URL}/${filePath}`;

  try {
    const response = await axios.put(uploadUrl, formData, {
      headers: fileHeaders,
      transformRequest: [(data) => data],
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });

    return response.data.name || response.data;
  } catch (error) {
    console.error("Upload error details:", {
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers,
    });
    throw error;
  }
}

export async function uploadFile(file, groupId = 0) {
  return uploadFileRequest(
    Number(groupId) !== 0 ? `${groupId}/image` : `image`,
    file
  );
}

export const getImageUrl = (path) => {
  if (path && !path.match(/^https?:\/\//)) {
    return MEDIA_API_URL + "/" + path;
  }

  return path;
};

export const handleImageUploadIfNeeded = async (imageFile, groupId) => {
  if (imageFile && typeof imageFile !== "string") {
    const image = await uploadFile(imageFile, groupId);
    // return getImageUrl(image)
    return image;
  }

  return imageFile;
};
export const getImgUrl = async (filename) => {
  try {
    const response = await axios.get(
      `${MEDIA_API_URL}/temp-url/image/${filename}`,
      {
        headers: {
          Authorization: `Bearer ${getSessionToken()}`,
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error getting image URL:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getImageFile = async (filename) => {
  try {
    const response = await axios.get(`${MEDIA_API_URL}/image/${filename}`, {
      headers: {
        Authorization: `Bearer ${getSessionToken()}`,
        Accept: "image/*",
        "Content-Type": "image/*",
      },
      responseType: "arraybuffer",
    });

    // Get file extension from filename
    const extension = filename.split(".").pop().toLowerCase();

    // Map file extensions to MIME types
    const mimeTypes = {
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      webp: "image/webp",
      svg: "image/svg+xml",
      bmp: "image/bmp",
      ico: "image/x-icon",
      tiff: "image/tiff",
      tif: "image/tiff",
    };

    const type = mimeTypes[extension] || "image/jpeg"; // fallback to jpeg if extension not found
    const blob = new Blob([response.data], { type });
    return blob;
  } catch (error) {
    console.error(
      "Error fetching image:",
      error.response?.data || error.message
    );
    throw error;
  }
};
